import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
// import Widgetdefinition from "./Widgetdefinition";
import Select from "react-select";

import LoadingOverlay from "./LoadingOverlay";
export default class Widgetsrightstable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.widgetsrightstable_Id,
          sortable: true,
          cell: (row) => <span>{row.widgetsrightstable_Id}</span>,
        },
        {
          name: "Widget",
          selector: (row, i) => row.widgetId,
          sortable: true,
          cell: (row) => <span>{row.widgetId}</span>,
        },
        {
          name: "Role Id",
          selector: (row, i) => row.roleId,
          sortable: true,
          cell: (row) => <span>{row.roleId}</span>,
        },
        {
          name: "User Id",
          selector: (row, i) => row.userID,
          sortable: true,
          cell: (row) => <span>{row.userID}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      // widgetId: "",
      // roleId: "",
      // userID: "",
      canView: false,
      canDrilldown: false,
      departmentId: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      widgetsrightstable_Id: "",
      isEditing: false,
      isNewEntry: false,
      employees: [],
      roles: [],
      widgetdefinition: [],
      widgetId: [],
      roleId: [],
      userID: [],
    };
  }
  //edit
  // handleEnterEditMode = (row) => {
  //   // Helper function to convert IDs to options
  //   const getWidgetOptions = (ids) => {
  //     const idArray = Array.isArray(ids) ? ids : [ids];
  //     return this.state.widgetdefinition
  //       .filter(widget => idArray.includes(widget.widgetdefinition_Id))
  //       .map(widget => ({
  //         value: widget.widgetdefinition_Id,
  //         label: `${widget.widgetName} - ${widget.chartType}`
  //       }));
  //   };

  //   const getRoleOptions = (ids) => {
  //     const idArray = Array.isArray(ids) ? ids : [ids];
  //     return this.state.roles
  //       .filter(role => idArray.includes(role.rName))
  //       .map(role => ({
  //         value: role.rName,
  //         label: role.rName
  //       }));
  //   };

  //   const getUserOptions = (ids) => {
  //     const idArray = Array.isArray(ids) ? ids : [ids];
  //     return this.state.employees
  //       .filter(emp => idArray.includes(emp.employees_Id))
  //       .map(emp => ({
  //         value: emp.employees_Id,
  //         label: `${emp.fName} ${emp.lName} (${emp.eId})`
  //       }));
  //   };

  //   this.setState({
  //     widgetsrightstable_Id: row.widgetsrightstable_Id,
  //     widgetId: getWidgetOptions(row.widgetId),
  //     roleId: getRoleOptions(row.roleId),
  //     userID: getUserOptions(row.userID),
  //     isEditing: true,
  //   });
  // };
handleEnterEditMode = (row) => {
  const roleOptions = this.state.roleOptions || [];
  const widgetOptions = this.state.widgetOptions || [];
  const userOptions = this.state.userOptions || [];

  const roleIdArray = row.roleId
    ? row.roleId.split(",").map(item => {
        const trimmed = item.trim();
        // Try to find by value (ID) first
        let found = roleOptions.find(option =>
          String(option.value) === String(trimmed)
        );
        // If not found, try by label (name)
        if (!found) {
          found = roleOptions.find(option =>
            String(option.label) === String(trimmed)
          );
        }
        return found;
      }).filter(Boolean)
    : [];

  // Same logic for widgets and users
  const widgetIdArray = row.widgetId
    ? row.widgetId.split(",").map(item => {
        const trimmed = item.trim();
        return widgetOptions.find(option =>
          String(option.value) === String(trimmed)
        );
      }).filter(Boolean)
    : [];

  const userIdArray = row.userID
    ? row.userID.split(",").map(item => {
        const trimmed = item.trim();
        return userOptions.find(option =>
          String(option.value) === String(trimmed)
        );
      }).filter(Boolean)
    : [];

  this.setState({
    widgetsrightstable_Id: row.widgetsrightstable_Id,
    widgetId: widgetIdArray,
    roleId: roleIdArray,
    userID: userIdArray,
    isEditing: true,
  });
};
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      widgetId: "",
      roleId: "",
      userID: "",
      canView: false,
      canDrilldown: false,
      departmentId: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg);

        break;

      default:
        toast.info(msg);
    }
  };
  WidgetsrightstableeditHandler = (e) => {
    e.preventDefault();
  };

  WidgetsrightstablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Widgetsrightstable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  EmployeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const userOptions = data.list.map(emp => ({
          value: emp.employees_Id,
          label: `${emp.fName} ${emp.lName} (${emp.eId})`
        }));
          this.setState({ employees: data.list,userOptions: userOptions });
        }
      });
  };
  getroleItems = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "roles/all", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        //window.showToast(data.message, data.status);
        if (data.status === "success") {
          const roleOptions = data.list.map(role => ({
          value: role.rId,
          label: role.rName
        }));
          // Initialize the checkbox data based on fetched table names
          this.setState({
            roles: data.list,
            roleOptions: roleOptions
          });
        }
      });
  };
  WidgetdefinationfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Widgetdefinition/listdashboard", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ widgetdefinition: data.list });
        }
      });
  };
  WidgetsrightstablesubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    //   setButtons(contacts);
    const widgetIds = this.state.widgetId.map((item) => item.value).join(",");
    const roleIds = this.state.roleId.map((item) => item.value).join(",");
    const userIds = this.state.userID.map((item) => item.value).join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetIds);
    formData.append("roleId", roleIds);
    formData.append("userID", userIds);
    formData.append("canView", this.state.canView);
    formData.append("canDrilldown", this.state.canDrilldown);
    formData.append("departmentId", this.state.departmentId);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Widgetsrightstable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.WidgetsrightstablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            widgetId: "",
            roleId: "",
            userID: "",
            canView: "",
            canDrilldown: "",
            departmentId: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });}).finally(() => this.setState({ isSubmitting: false }))
    .catch(() => { this.setState({ loading: false }); });
  };
  WidgetsrightstableupdateHandler = (e) => {
    e.preventDefault();
    const widgetIds = this.state.widgetId.map((item) => item.value).join(",");
    const roleIds = this.state.roleId.map((item) => item.value).join(",");
    const userIds = this.state.userID.map((item) => item.value).join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetIds);
    formData.append("roleId", roleIds);
    formData.append("userID", userIds);
    formData.append("canView", this.state.canView);
    formData.append("canDrilldown", this.state.canDrilldown);
    formData.append("departmentId", this.state.departmentId);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("widgetsrightstable_Id", this.state.widgetsrightstable_Id);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Widgetsrightstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.WidgetsrightstablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.WidgetsrightstablefetchHandler();
    this.WidgetdefinationfetchHandler();
    this.getroleItems();
    this.EmployeesfetchHandler();
  }
  // handlewidgetIdChange = (e) => {
  //   e.preventDefault();
  //   const fieldValue = e.target.value;
  //   this.setState({ widgetId: fieldValue });
  // };
  // handleroleIdChange = (e) => {
  //   e.preventDefault();
  //   const fieldValue = e.target.value;
  //   this.setState({ roleId: fieldValue });
  // };
  // handleuserIDChange = (e) => {
  //   e.preventDefault();
  //   const fieldValue = e.target.value;
  //   this.setState({ userID: fieldValue });
  // };
  handlewidgetIdChange = (selectedOptions) => {
    this.setState({
      widgetId: selectedOptions || [],
      errors: { ...this.state.errors, widgetId: "" },
    });
  };

  handleroleIdChange = (selectedOptions) => {
    this.setState({
      roleId: selectedOptions || [],
      errors: { ...this.state.errors, roleId: "" },
    });
  };

  handleuserIDChange = (selectedOptions) => {
    this.setState({
      userID: selectedOptions || [],
      errors: { ...this.state.errors, userID: "" },
    });
  };
  handlecanViewChange = (e) => {
    const isChecked = e.target.checked; // Get the checkbox state
    this.setState({ canView: isChecked });
  };

  handlecanDrilldownChange = (e) => {
    e.preventDefault();
    const isChecked = e.target.checked;
    this.setState({ canDrilldown: isChecked });
  };
  handlecanDepartmentIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ departmentId: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetsrightstable_Id", row.widgetsrightstable_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Widgetsrightstable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.WidgetsrightstablefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );
    const widgetOptions = this.state.widgetdefinition.map((api) => ({
      value: api.widgetdefinition_Id,
      label: `${api.widgetName} - ${api.chartType}`,
    }));

    const roleOptions = this.state.roles.map((api) => ({
      value: api.rName,
      label: api.rName,
    }));

    const userOptions = this.state.employees.map((api) => ({
      value: api.employees_Id,
      label: `${api.fName} ${api.lName} (${api.eId})`,
    }));

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Widgets Rights Table
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "600px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Widgetsrightstable page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Widget
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      {/* <select
                                        className="form-select"
                                        name="widgetId"
                                        value={this.state.widgetId}
                                        required="required"
                                        placeholder="Enter widgetId"
                                        onChange={this.handlewidgetIdChange}
                                      >
                                        <option defaultValue>
                                          Select Widget Id
                                        </option>
                                        {this.state.widgetdefinition.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.widgetdefinition_Id}
                                            >
                                              {api.widgetName}{api.chartType}
                                            </option>
                                          )
                                        )}
                                      </select> */}
                                      <Select
                                        isMulti
                                        options={widgetOptions}
                                        value={this.state.widgetId}
                                        onChange={this.handlewidgetIdChange}
                                        placeholder="-- Select Widgets --"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        isClearable
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.widgetId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Role Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      {/* <select
                                        className="form-select"
                                        onChange={this.handleroleIdChange}
                                        name="roleId"
                                        value={this.state.roleId}
                                        required="required"
                                        placeholder="Enter roleId"
                                      >
                                        <option defaultValue>
                                          Select Role Id
                                        </option>
                                        {this.state.roles.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.rName}
                                            >
                                            {api.rName}
                                            </option>
                                          )
                                        )}
                                      </select> */}
                                      <Select
                                        isMulti
                                        options={roleOptions}
                                        value={this.state.roleId}
                                        onChange={this.handleroleIdChange}
                                        placeholder="-- Select Roles --"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        isClearable
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.roleId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      {/* <select
                                        className="form-select"
                                        onChange={this.handleuserIDChange}
                                        name="userID"
                                        value={this.state.userID}
                                        required="required"
                                        placeholder="Enter user ID"
                                      >
                                        <option defaultValue>
                                          Select User Id
                                        </option>
                                        {this.state.employees.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.employees_Id}
                                            >
                                              {api.fName}{api.lName}{api.eId}
                                            </option>
                                          )
                                        )}
                                      </select> */}
                                      <Select
                                        isMulti
                                        options={userOptions}
                                        value={this.state.userID}
                                        onChange={this.handleuserIDChange}
                                        placeholder="-- Select Users --"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        isClearable
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userID}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Can View</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Check
                                        type="checkbox"
                                        onChange={this.handlecanViewChange}
                                        className="form-check"
                                        name="canView"
                                        checked={this.state.canView}
                                      />
                                    </Col>
                                  </Row>

                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Can Drilldown</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Check
                                        type="checkbox"
                                        onChange={this.handlecanDrilldownChange}
                                        className="form-check-view"
                                        name="canDrilldown"
                                        checked={this.state.canDrilldown}
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Department Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecanDepartmentIDChange
                                        }
                                        className="form-control"
                                        name="departmentId"
                                        value={this.state.departmentId}
                                        required="required"
                                        placeholder="Enter Department Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userID}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        DummyOne
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter dummyOne"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter dummyTwo"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Three
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyThreeChange}
                                        className="form-control"
                                        name="dummyThree"
                                        value={this.state.dummyThree}
                                        required="required"
                                        placeholder="Enter dummyThree"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyThree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Four
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFourChange}
                                        className="form-control"
                                        name="dummyFour"
                                        value={this.state.dummyFour}
                                        required="required"
                                        placeholder="Enter dummyFour"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFour}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Five
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFiveChange}
                                        className="form-control"
                                        name="dummyFive"
                                        value={this.state.dummyFive}
                                        required="required"
                                        placeholder="Enter dummyFive"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFive}{" "}
                                    </div>
                                  </Row> */}
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "25px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.WidgetsrightstablesubmitHandler} disabled={this.state.isSubmitting}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                        {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</>) : "Save"}
                      </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    {this.state.isEditing && (
                      <Offcanvas
                        show={this.state.isEditing}
                        onHide={() => this.setState({ isEditing: false })}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Widgets rights table page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Widget
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlewidgetIdChange}
                                        className="form-control"
                                        name="widgetId"
                                        value={this.state.widgetId}
                                        required="required"
                                        placeholder="Enter widgetId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.widgetId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Role Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      {/* <Form.Control
                                        type="text"
                                        onChange={this.handleroleIdChange}
                                        className="form-control"
                                        name="roleId"
                                        value={this.state.roleId}
                                        required="required"
                                        placeholder="Enter roleId"
                                      /> */}
                                      <Select
                                        isMulti
                                        options={roleOptions}
                                        value={this.state.roleId}
                                        onChange={this.handleroleIdChange}
                                        placeholder="-- Select Roles --"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        isClearable
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.roleId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        User Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Select
                                        isMulti
                                        options={userOptions}
                                        value={this.state.userID}
                                        onChange={this.handleuserIDChange}
                                        placeholder="-- Select Users --"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        isClearable
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userID}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Can View</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Check
                                        type="checkbox"
                                        onChange={this.handlecanViewChange}
                                        className="form-check"
                                        name="canView"
                                        checked={this.state.canView}
                                      />
                                    </Col>
                                  </Row>

                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Can Drilldown</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Check
                                        type="checkbox"
                                        onChange={this.handlecanDrilldownChange}
                                        className="form-check-view"
                                        name="canDrilldown"
                                        checked={this.state.canDrilldown}
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Department Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlecanDepartmentIDChange
                                        }
                                        className="form-control"
                                        name="departmentId"
                                        value={this.state.departmentId}
                                        required="required"
                                        placeholder="Enter Department Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.userID}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        DummyOne
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter dummyOne"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter dummyTwo"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Three
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyThreeChange}
                                        className="form-control"
                                        name="dummyThree"
                                        value={this.state.dummyThree}
                                        required="required"
                                        placeholder="Enter dummyThree"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyThree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Four
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFourChange}
                                        className="form-control"
                                        name="dummyFour"
                                        value={this.state.dummyFour}
                                        required="required"
                                        placeholder="Enter dummyFour"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFour}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Five
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFiveChange}
                                        className="form-control"
                                        name="dummyFive"
                                        value={this.state.dummyFive}
                                        required="required"
                                        placeholder="Enter dummyFive"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFive}{" "}
                                    </div>
                                  </Row> */}
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "25px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.WidgetsrightstableupdateHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Update
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                    )}
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
